import { render, staticRenderFns } from "./kycFileCN.vue?vue&type=template&id=3f74c865&scoped=true&"
import script from "./kycFileCN.vue?vue&type=script&lang=js&"
export * from "./kycFileCN.vue?vue&type=script&lang=js&"
import style0 from "./kycFileCN.vue?vue&type=style&index=0&id=3f74c865&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f74c865",
  null
  
)

export default component.exports